import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { LieferungPosition, deleteLieferungPosition } from 'api/lieferungPosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface LieferungPositionDeleteProps {
    lieferungPosition: LieferungPosition;
    onClose: (refetch: boolean) => void;
}

export const LieferungPositionDelete: React.FC<LieferungPositionDeleteProps> = ({ lieferungPosition, onClose }) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (lieferungPosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteLieferungPosition(lieferungPosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Lieferungsposition löschen',
                subText: 'Lieferungsposition "' + lieferungPosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
